import { DataBean } from "../DataBean";

export class BankingConciliationReport extends DataBean {


    public async getBankingConciliation(idBankingAccount:any,year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingConciliation_Number_Number_Number", [idBankingAccount,year,month]);
    }

}